"use client";

import { Modal } from "@mantine/core";

import { Button, Stack, Text } from "@/components/ui/elements";

type Props = {
  opened: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * 本人確認が承認済みのワーカーが、本人確認書類と照合した項目（氏名・性別・生年月日・住所）や、就労可否判定の根拠になる国籍を変更して保存しようとしたときの確認ダイアログ。
 * 保存すると本人確認済みが外れるため、保存する前に本人確認書類の再提出が必要になることを伝える。
 */
export function IdentityResubmissionConfirmModal({
  opened,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title="本人確認書類の再提出について"
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm">
          お名前・生年月日・性別・国籍・住所を変更すると、
          <Text span inherit fw={700}>
            本人確認書類の再提出が必要になります。
          </Text>
          この内容で保存してよろしいですか。
        </Text>
        <Text size="sm" c="dimmed">
          再提出した本人確認書類が承認されるまで、お仕事に応募できません。
        </Text>
        {/* Button の既定は size="lg" で、横並びだと文言が長く折り返すため縦に積む */}
        <Stack gap="xs">
          <Button
            type="button"
            color="teal"
            size="md"
            fullWidth
            onClick={onConfirm}
          >
            変更を保存する
          </Button>
          <Button
            type="button"
            variant="outline"
            color="gray"
            size="md"
            fullWidth
            onClick={onCancel}
          >
            キャンセル
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
